import {Step} from './step';

export abstract class LoanApplicationFlowStep implements Step {
    public static readonly BorrowFlowBaseUrl = 'borrow';

    public createBorrowerFlowUrl(suffix: string) {
        return LoanApplicationFlowStep.BorrowFlowBaseUrl + '/' + suffix;
    }

    abstract isComplete(): Promise<boolean>;

    abstract url(): string;

    abstract displayName(): string;

    abstract description(): string;

    showWelcomePageOnLeftPane(): boolean {
        return false;
    }
    isOptional(): boolean {
        return false;
    }
}
